import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          读者评论
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          听听访问者们怎么说
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="flex flex-col gap-3 p-5 bg-background-50 border border-background-200/60 rounded-lg"
            >
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-sm font-bold shrink-0">
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800">{comment.author}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-500 mt-auto">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}